import script from "./WorkList.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkList.vue?vue&type=script&setup=true&lang=js"

import "./WorkList.vue?vue&type=style&index=0&id=28672707&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28672707"]])

export default __exports__